import { OrderStatusObject } from '../order-status-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderTypeObject } from '../order-type-object.model';
import { isNullOrUndefined } from 'util';

export class TreeCardObject {

  private orderId: string;
  private operation: string;
  private tooltip: string;
  private chidren: Array<TreeCardObject>;
  private index: number;
  private clicked: boolean;

  constructor(private name: string, private description: string, private info: string,
    private completed: boolean, private crmId: string, operation: string,
    private status: OrderStatusObject, private dependencies: boolean, private level: number,
    orderId: string, private type: OrderTypeObject) {

    this.operation = !isNullOrUndefined(operation) ? operation.trim().toUpperCase() : '';
    this.clicked = false;

    if ((crmId != null) && (status != null)) {
      if (this.completed) {
        this.orderId = orderId;
        this.tooltip = ' Provision Process \n Status: COMPLETED \n Id: ' + this.crmId;
      } else {
        this.tooltip = ' Provision Process \n Status: CREATED \n Id: ' + this.crmId;
      }
    } else { this.tooltip = ''; }
    this.chidren = [];
    this.index = 0;
    this.orderId = orderId;
  }


  static create(): TreeCardObject {
    return new TreeCardObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
      false, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, OrderStatusObject.create(), false, 0,
      StringUtils.NOT_AVALIABLE, OrderTypeObject.UNKNOWN);
  }

  public getName(): string {
    return this.name;
  }

  public getDescription(): string {
    return this.description;
  }

  public getInfo(): string {
    return this.info;
  }

  public isCompleted(): boolean {
    return this.completed;
  }

  public getCrmId(): string {
    return this.crmId;
  }

  public getOperation(): string {
    return this.operation;
  }

  public getStatus(): OrderStatusObject {
    return this.status;
  }

  public getLevel(): number {
    return this.level;
  }

  public setLevel(level: number): void {
    this.level = level;
  }

  public getTooltip(): string {
    return this.tooltip;
  }

  public hasDependencies(): boolean {
    return this.dependencies;
  }

  public getChildren(): Array<TreeCardObject> {
    return this.chidren;
  }

  public addChildren(treeCardObject: TreeCardObject): void {
    this.chidren.push(treeCardObject);
  }

  public hasChildren() {
    return this.getChildren().length !== 0;
  }

  public getIndex() {
    return this.index;
  }

  public setIndex(index: number) {
    this.index = index;
  }

  public getOrderId(): string {
    return this.orderId;
  }

  public setOrderId(orderId: string) {
    this.orderId = orderId;
  }

  public setClicked(clicked: boolean) {
    this.clicked = clicked;
  }

  public isClicked(): boolean {
    return this.clicked;
  }

  public click(): void {
    this.clicked = !this.clicked;
  }

  public getType(): OrderTypeObject {
    return this.type;
  }

  public equals(treeCard: TreeCardObject): boolean {
    return this.name === treeCard.name && this.orderId === treeCard.orderId;
  }
}

